<p-card [style]="{ 'width': '75vw' }">
  <div class="flex w-full">
    <div *ngIf="pageVars.isReady" class="flex" style="width: 15rem">
      <p-table
        #dt
        [value]="containers"
        dataKey="id"
        [scrollable]="true"
        scrollHeight="60vh"
        selectionMode="single"
        [(selection)]="selectedContainer"
        (onRowSelect)="containerSelected()"
        (onRowUnselect)="containerUnselected()"
        [globalFilterFields]="['name', 'containerType.name']">
        <ng-template #caption>
          <p-iconfield iconPosition="left" class="ml-auto">
            <p-inputicon>
              <i class="pi pi-search"></i>
            </p-inputicon>
            <input #searchBox pInputText type="text" (input)="dt.filterGlobal(searchBox.value, 'contains')" placeholder="Search keyword" />
          </p-iconfield>
        </ng-template>
        <ng-template #body let-item>
          <tr [pSelectableRow]="item">
            <div
              style="
                margin: 0.25rem;
                border: 1px solid lightgray;
                padding: 1rem;
                border-radius: 0.5rem;
                box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.15);
              ">
              <div style="font-size: normal; font-weight: normal">{{ item.name }}</div>
              <div class="flex w-full text-xs">{{ item.containerType.name }}</div>
              <div *ngIf="item.isActive == false" class="flex w-full text-red-500 text-xs">Inactive</div>
            </div>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div *ngIf="pageVars.isReady && !pageVars.isLoading" class="flex ml-4" style="width: 70rem">
      <p-accordion value="0" *ngIf="selectedContainer" class="w-full">
        <p-accordion-panel value="0">
          <p-accordion-header>Insects</p-accordion-header>
          <p-accordion-content>
            <p-treetable [value]="insectGrowthStagesNodes" [scrollable]="true" dataKey="key">
              <ng-template pTemplate="header">
                <tr style="font-size: small">
                  <th>Species / Growth Stage</th>
                  <th>Available</th>
                  <th>Infestation Rate</th>
                  <th></th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-rowIndex="rowIdx">
                <tr [ttRow]="rowNode">
                  <td *ngIf="rowData.nodeType === 'parent'" colspan="4">
                    <p-treeTableToggler [rowNode]="rowNode" />
                    <span *ngIf="rowData.nodeType === 'parent'" style="font-weight: bold">{{ rowData.item.scientificName }}</span>
                  </td>
                  <td *ngIf="rowData.nodeType !== 'parent'">
                    <span *ngIf="rowData.nodeType !== 'parent'" style="font-weight: normal">{{ rowData.item.growthStageName }}</span>
                    <div *ngIf="rowData.item.isActive == false" class="flex w-full text-red-500 text-xs">Inactive</div>
                  </td>
                  <td *ngIf="rowData.nodeType !== 'parent'">
                    <p-toggleswitch
                      *ngIf="rowData.nodeType === 'child'"
                      [(ngModel)]="rowData.item.isAvailable"
                      [disabled]="rowData.item.isActive === false"
                      attr.data-testid="isAvailable{{ rowData.item.id }}"
                      (change)="insectGrowthStageUpdate(rowData.item)" />
                  </td>
                  <td *ngIf="rowData.nodeType !== 'parent'" style="width: 20rem">
                    <div class="flex">
                      <p-inputnumber
                        *ngIf="rowData.nodeType === 'child'"
                        id="infestationRate"
                        name="infestationRate"
                        [(ngModel)]="rowData.item.infestationRate"
                        inputId="infestationRate"
                        suffix=" per {{ selectedContainer.containerType.name }}"
                        [min]="0"
                        [minFractionDigits]="0"
                        [maxFractionDigits]="0"
                        [useGrouping]="false"
                        attr.data-testid="infestationRate{{ rowData.item.id }}"
                        [disabled]="rowData.item.isActive === false || rowData.item.isAvailable === false"
                        (onInput)="insectGrowthStageUpdate(rowData.item)" />
                    </div>
                  </td>
                  <td *ngIf="rowData.nodeType !== 'parent'">
                    <app-audit-info *ngIf="rowData.nodeType === 'child'" [value]="rowData.item" [direction]="'vertical'"></app-audit-info>
                  </td>
                </tr>
              </ng-template>
            </p-treetable>
          </p-accordion-content>
        </p-accordion-panel>
        <p-accordion-panel value="1">
          <p-accordion-header>Substrates</p-accordion-header>
          <p-accordion-content>
            <p-table [value]="substrates" dataKey="id" class="table-sm">
              <ng-template #header>
                <tr>
                  <th>Substrate</th>
                  <th style="width: 5rem; text-align: center">Available</th>
                  <th>Standard Amount</th>
                  <th style="text-align: end; vertical-align: middle"></th>
                </tr>
              </ng-template>
              <ng-template #body let-substrate>
                <tr>
                  <td>
                    <div class="flex w-full">{{ substrate.substrateName }}</div>
                    <div *ngIf="substrate.isActive == false" class="flex w-full text-red-500 text-xs">Inactive</div>
                  </td>
                  <td>
                    <p-toggleswitch
                      [(ngModel)]="substrate.isAvailable"
                      (change)="substrateUpdate(substrate)"
                      [disabled]="substrate.isActive == false"
                      attr.data-testid="isAvailable{{ substrate.id }}" />
                  </td>
                  <td>
                    <div class="flex align-items-center">
                      <p-inputnumber
                        id="standardVolume"
                        name="standardVolume"
                        [(ngModel)]="substrate.standardVolume"
                        inputId="standardVolume"
                        class="width-7 mr-2"
                        [useGrouping]="false"
                        [min]="0"
                        [minFractionDigits]="0"
                        [maxFractionDigits]="3"
                        (onInput)="substrateUpdate(substrate)"
                        attr.data-testid="standardVolume{{ substrate.id }}"
                        [disabled]="substrate.isActive === false || substrate.isAvailable === false"
                        placeholder="Amount"
                        #standardVolumeInput="ngModel"
                        [ngClass]="{
                          'ng-invalid':
                            (substrate.standardVolume && !substrate.standardVolumeUom) || (!substrate.standardVolume && substrate.standardVolumeUom)
                        }"
                        appendTo="body" />
                      <p-select
                        [(ngModel)]="substrate.standardVolumeUom"
                        [options]="unitsOfMeasure"
                        [showClear]="true"
                        optionLabel="text"
                        optionValue="text"
                        [disabled]="substrate.isActive === false || substrate.isAvailable === false"
                        (onChange)="substrateUpdate(substrate)"
                        attr.data-testid="standardVolumeUom{{ substrate.id }}"
                        placeholder="Units"
                        autoDisplayFirst="true"
                        #standardVolumeUomInput="ngModel"
                        [ngClass]="{
                          'ng-invalid':
                            (substrate.standardVolume && !substrate.standardVolumeUom) || (!substrate.standardVolume && substrate.standardVolumeUom)
                        }"
                        appendTo="body"></p-select>
                    </div>
                  </td>
                  <td>
                    <app-audit-info [value]="substrate" [direction]="'vertical'"></app-audit-info>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </p-accordion-content>
        </p-accordion-panel>
      </p-accordion>
    </div>
  </div>
</p-card>
